import BN from 'bn.js';

export const convertNumberToCurrency = (
  amount: number,
  decimals: number = 0
) => {
  return `${amount
    .toFixed(decimals)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
};

export const formatTokenAmount = (num: string): string => {
  if (!num || isNaN(Number(num))) {
    return '0.000000000';
  }

  const [wholePart, decimalPart] = num.split('.');
  const wholeBN = new BN(wholePart);

  // ✅ If >= 1K, remove decimals and format
  if (wholeBN.gte(new BN(1_000_000_000)))
    return wholeBN.div(new BN(1_000_000_000)).toString() + 'B';
  if (wholeBN.gte(new BN(1_000_000)))
    return wholeBN.div(new BN(1_000_000)).toString() + 'M';
  if (wholeBN.gte(new BN(1_000)))
    return wholeBN.div(new BN(1_000)).toString() + 'K';

  return wholePart;
};

export const convertToLamports = (amount: string): string | null => {
  if (!amount || isNaN(Number(amount))) {
    return null; // Invalid input
  }

  // Ensure the amount has at most 9 decimal places
  const amountStr = amount.toString();
  if (amountStr.includes('.') && amountStr.split('.')[1].length > 5) {
    return null; // Reject invalid input
  }

  // Convert to BigInt (WSOL lamports)
  const lamports = BigInt(Math.round(parseFloat(amount) * 10 ** 5));

  return lamports.toString(); // Return as string for JSON safety
};
